var map = {
	"./da.json": "df88",
	"./de.json": "bac1",
	"./en.json": "e312",
	"./es.json": "ef52",
	"./fr.json": "b16e",
	"./it.json": "669f",
	"./nl.json": "b94d",
	"./sv.json": "fdde9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a35b";